import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b8a06ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper flex w-full" }
const _hoisted_2 = { class: "banner-text flex-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-title" }, "Get 500 spice points", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-subtitle" }, "In Liquidity providers competition", -1))
const _hoisted_5 = {
  key: 0,
  class: "logos flex gap-2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/banners/liquidity-competition/bob-logo.png",
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/banners/liquidity-competition/intract-logo.png",
  alt: ""
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "logos flex gap-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/banners/liquidity-competition/bob-logo.png",
  alt: ""
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/banners/liquidity-competition/intract-logo.png",
  alt: ""
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import { INTRACT_LINK } from '@/constants/EXTERNAL_LINKS';
import { useUtils } from '@/composables/utils/useUtils';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'LiquidityCompetitionBanner',
  setup(__props) {

const { state } = useStore();
const { openExternalLink } = useUtils();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "banner relative",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openExternalLink)(_unref(INTRACT_LINK))))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        (_unref(state).layout.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      (!_unref(state).layout.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})